<template>
  <v-layout v-if="items == null" justify-center align-center>
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-layout>
  <v-list v-else>
    <v-list-group
      v-for="item in items"
      :key="item.title"
      v-model="item.active"
      :value="value"
      :prepend-icon="item.active ? 'check_circle' : 'check_circle_outline'"
      no-action
    >
      <template v-slot:activator>
        <v-list-tile>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
      </template>

      <RefWidget
        v-bind="item.schema"
        :show-buttons="true"
        :value="value"
        @refChanged="refChanged"
      />
    </v-list-group>
  </v-list>
</template>

<script>
import ApiService from '../APIService'

export default {
  name: 'OneOfRefWidget',
  components: {
    RefWidget: () => import('../../rd-forms/complex_widgets/RefWidget.vue')
  },
  props: {
    refs: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      default: null
    },
    entityId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      items: null,
      schema: [],
      formValues: {},
      keysByEntityId: {},
      active: false
    }
  },
  created: function() {
    if (this.value === undefined) {
      for (let i in this.refs) {
        ApiService.getEntity(this.refs[i]).then((res) => {
          this.items.push({
            title: res.data.title,
            schema: {
              entityId: this.refs[i]
            }
          })
        })
      }
    }
  },
  mounted() {
    this.loadEntitiesTitles()
  },
  methods: {
    async loadEntitiesTitles() {
      this.items = []
      for (let i in this.refs) {
        await ApiService.getEntity(this.refs[i]).then((res) => {
          if (this.refs[i] === this.value.entityId) {
            this.items.push({
              title: res.data.title,
              active: true,
              schema: {
                entityId: this.refs[i]
              }
            })
          }
          if (this.refs[i] !== this.value.entityId) {
            this.items.push({
              title: res.data.title,
              active: false,
              schema: {
                entityId: this.refs[i]
              }
            })
          }
        })
      }
    },
    refChanged(value) {
      this.$emit('input', value)
    }
  }
}
</script>
